import { useRef, useState } from 'react'

import { cn } from '@/lib/utils'
import { gsap, registerGsap, prefersReducedMotion } from '@/lib/gsap'
import { useIsomorphicLayoutEffect } from '@/hooks/use-isomorphic-layout-effect'

import { VideoLightbox } from './video-lightbox'

interface ReelCircleProps {
    className?: string
}

// Rotating "play showreel" badge. Triggers the circle-video cursor on hover and
// opens the reel lightbox on click.
export function ReelCircle({ className }: ReelCircleProps) {
    const badgeRef = useRef<HTMLImageElement>(null)
    const [open, setOpen] = useState(false)

    useIsomorphicLayoutEffect(() => {
        const el = badgeRef.current
        if (!el || prefersReducedMotion()) return
        registerGsap()
        const ctx = gsap.context(() => {
            gsap.to(el, { rotate: 360, duration: 20, ease: 'none', repeat: -1 })
        })
        return () => ctx.revert()
    }, [])

    return (
        <div className={cn('play-reel-circle-holder', className)}>
            <button
                type='button'
                className='play-reel-circle'
                data-cursor='video'
                aria-label='Play showreel'
                onClick={() => setOpen(true)}
                style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'none'
                }}
            >
                <img
                    ref={badgeRef}
                    src='/images/Reel-Circle.svg'
                    alt=''
                    className='reel-circle'
                />
            </button>
            <VideoLightbox open={open} onClose={() => setOpen(false)} />
        </div>
    )
}
